import { createCascadeApi } from '@cascade/api-client/cascade-api';
import { createAuth } from '@cascade/core/auth';
import { createHttpClient } from '@cascade/core/connection';
import {
  readMagicAuthEmail,
  rememberMagicAuthEmail,
} from '@cascade/react-dom/authentication';

export const createClients = (apiUrl: string) => {
  const http = createHttpClient({ url: apiUrl });
  const api = createCascadeApi(http);
  const magicAuthEmail = readMagicAuthEmail();
  const auth = createAuth({
    api,
    platform: 'app',
    magicAuthEmail,
    onMagicAuthEmailChange: rememberMagicAuthEmail,
  });

  return { api, auth };
};
